import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '';

const client = axios.create({ baseURL: BASE });

client.interceptors.request.use(cfg => {
  const token = localStorage.getItem('vfs_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

client.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vfs_token');
      localStorage.removeItem('vfs_phone');
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export const checkPhone = (phone) => client.post('/api/auth/check-phone', { phone });
export const setPin = (phone, pin_code, geo) => client.post('/api/auth/set-pin', { phone, pin_code, geo });
export const verifyPin = (phone, pin_code, geo) => client.post('/api/auth/verify-pin', { phone, pin_code, geo });
export const forgotPin = (phone) => client.post('/api/auth/forgot-pin', { phone });
export const getStatus = () => client.get('/api/client/status');
export const startOrder = (formData) => client.post('/api/visa/start-order', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const resetStatus = () => client.post('/api/visa/reset-status');
export const uploadBalance = (formData) => client.post('/api/visa/upload-balance', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getSupportMessages = () => client.get('/api/support/messages');
export const sendSupportMessage = (text) => client.post('/api/support/send', { text });
export const saveFcmToken = (token) => client.post('/api/client/fcm-token', { token });
export const savePing = (ping, connType, battery) => client.post('/api/client/ping', { ping, conn_type: connType, battery });
